import {Skeleton} from "@mui/material"
import {styled} from "@mui/material/styles"

export const LoadingSpinner = styled("span")`
    width: 2.75rem;
    height: 2.75rem;
    outline: none;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    &.loaded {
        &::after {
            content: none;
            transition: none;
        }
    }
    &.loading {
        position: relative;
        transition: all 0.2s ease-in;
        &::after {
            content: "";
            opacity: 0;
            position: absolute;
            border-radius: 100%;
            width: 0px;
            height: 0px;
            border: 0.125rem solid rgba(102, 143, 112, 0.05);
            border-left-color: ${({theme}) => theme.colours.form.buttonPrimary.background};
            border-top-color: ${({theme}) => theme.colours.form.buttonPrimary.background};
            animation: spin 0.6s infinite linear, grow 0.3s forwards ease-out;
            transition: opacity 0.3s ease;
        }
    }

    @keyframes spin {
        to {
            transform: rotate(359deg);
            opacity: 1;
        }
    }
    @keyframes grow {
        to {
            opacity: 1;
            width: 0.75rem;
            height: 0.75rem;
        }
    }
    @keyframes strokeExpand {
        from {
            height: 0;
        }
        to {
            height: 100%;
        }
    }
    @keyframes strokeExpand2 {
        from {
            width: 0;
        }
        to {
            width: 100%;
        }
    }
`

export const SpinnerWrapper = styled("div")`
    position: absolute;
    display: flex;
    align-items: center;
    right: 0;
    margin-top: auto;
    margin-bottom: auto;
    top: 0;
    bottom: 0;
`

export const HiddenNoTranslationFacetValue = styled("span")`
    display: none;
`

export const TitleContainer = styled("span")`
    display: flex;
    align-items: center;
    letter-spacing: normal;
    margin-top: 0rem;

    text-transform: ${({theme}) => theme.colours.typography.body2.textTransform};
    font-weight: inherit;
    font-size: inherit;
    font-family: ${({theme}) =>
        `${theme.colours.font.primary.regular.family}, ${theme.colours.font.default}`} !important; // This is to override MVC changes
`
interface ThumbnailProps {
    imageLoaded: boolean
}
export const FilterThumbnail = styled("img")<ThumbnailProps>`
    margin-right: 0.75rem;
    height: 2.75rem;
    width: 2.75rem;
    display: ${({imageLoaded}) => (imageLoaded ? "block" : "none")};
`
export const FilterThumbnailPlaceholder = styled(Skeleton)<ThumbnailProps>`
    margin-right: 0.75rem;
    height: 2.75rem;
    width: 2.75rem;
    display: ${({imageLoaded}) => (imageLoaded ? "none" : "block")};
`
